import keyCodes from '../constants/key-strings';

let toggling = false;

/**
 * Handles select dropdown toggling.
 *
 * @param {Event|{preventDefault: Function, currentTarget: HTMLElement}} e - event for selecting an option
 */
const toggleSelect = e => {
    e.preventDefault();
    if (!toggling) {
        toggling = true;
        const selectContainer = e.currentTarget;
        const selectOptions = selectContainer.querySelector('.custom-select__options');

        const selectIcons = selectContainer.querySelectorAll('.selection-icon .icon');
        $(selectOptions).toggle('medium', () => {
            selectIcons.forEach(icon => icon.classList.toggle('active'));
            selectContainer.classList.toggle('is-open');
            toggling = false;
            if (selectContainer.classList.contains('is-open')) {
                selectOptions.setAttribute('aria-expanded', true);
            } else {
                selectOptions.setAttribute('aria-expanded', false);
            }
        });
    }
};

/**
 * Toggles the optional textarea if applicable.
 *
 * @param {HTMLElement} selectContainer - custom select container
 * @param {HTMLElement} currentOption - current selected option from the select dropdown
 */
const toggleTextArea = (selectContainer, currentOption) => {
    const additionalTextContainer = selectContainer.nextElementSibling;
    const textArea = additionalTextContainer ? additionalTextContainer.querySelector('#additional-text') : null;
    if (textArea !== null) {
        if (currentOption.dataset.showTextarea) {
            $(additionalTextContainer).fadeIn();
        } else {
            textArea.value = '';
            textArea.classList.remove('filled-out');
            const textAreaLabel = additionalTextContainer.querySelector('label');
            textAreaLabel.innerHTML = textAreaLabel.dataset.initialState || textAreaLabel.innerHTML;
            $(additionalTextContainer).fadeOut();
        }
    }
};

/**
 * Handles option selection.
 *
 * @param {Event|{preventDefault: Function, currentTarget: HTMLElement}} e - event for selecting an option
 */
const selectOptionHandler = e => {
    e.preventDefault();
    const currentOption = e.currentTarget;
    const selectOptions = currentOption.parentElement;
    const selectContainer = selectOptions.parentElement;

    const selectionText = selectContainer.querySelector('.selection-text');
    selectionText.innerHTML = currentOption.innerHTML;
    selectionText.classList.remove('is-bold');
    selectContainer.querySelector('input[name="selectedOption"]').value = currentOption.dataset.value;
    selectOptions.setAttribute('aria-activedescendant', currentOption.id);
    toggleTextArea(selectContainer, currentOption);
    toggleSelect({currentTarget: selectContainer, preventDefault: e.preventDefault.bind(e)});
};

/**
 * Handles keyboard navigation of the custom select.
 *
 * @param {Event} e - event for selecting an option
 * @param {HTMLElement} selectContainer - custom select container
 */
const keyboardNavigate = (e, selectContainer) => {
    e.preventDefault();
    const selectOptions = selectContainer.querySelector('.custom-select__options');
    const allOptions = [...selectOptions.querySelectorAll('.custom-select__option')];
    let focusedOption = selectContainer.querySelector('.custom-select__option.is-focused');

    if (
        e.key === keyCodes.ENTER ||
        e.key === keyCodes.SPACE ||
        e.key === keyCodes.SPACE_IE11 ||
        e.key === keyCodes.ESCAPE ||
        e.key === keyCodes.ESCAPE_IE11 ||
        (e.altKey &&
            (e.key === keyCodes.ARROW_DOWN ||
                e.key === keyCodes.ARROW_UP ||
                e.key === keyCodes.ARROW_UP_IE11 ||
                e.key === keyCodes.ARROW_DOWN_IE11))
    ) {
        if (focusedOption !== null) {
            selectOptionHandler({currentTarget: focusedOption, preventDefault: e.preventDefault.bind(e)});
        } else {
            toggleSelect(e);
        }
    } else if (e.key === keyCodes.ARROW_DOWN || e.key === keyCodes.ARROW_DOWN_IE11) {
        if (focusedOption === null) {
            [focusedOption] = allOptions;
            focusedOption.classList.add('is-focused');
        } else if (focusedOption !== selectOptions.lastElementChild) {
            focusedOption.classList.remove('is-focused');
            focusedOption = allOptions[allOptions.indexOf(focusedOption) + 1];
            focusedOption.classList.add('is-focused');
        }
    } else if (
        (e.key === keyCodes.ARROW_UP || e.key === keyCodes.ARROW_UP_IE11) &&
        focusedOption !== null &&
        focusedOption !== selectOptions.firstElementChild
    ) {
        focusedOption.classList.remove('is-focused');
        focusedOption = allOptions[allOptions.indexOf(focusedOption) - 1];
        focusedOption.classList.add('is-focused');
    } else if (e.key === keyCodes.HOME || e.key === keyCodes.PAGE_UP) {
        if (focusedOption !== null) {
            focusedOption.classList.remove('is-focused');
        }
        [focusedOption] = allOptions;
        focusedOption.classList.add('is-focused');
    } else if (e.key === keyCodes.END || e.key === keyCodes.PAGE_DOWN) {
        if (focusedOption !== null) {
            focusedOption.classList.remove('is-focused');
        }
        focusedOption = allOptions[allOptions.length - 1];
        focusedOption.classList.add('is-focused');
    }
};

/**
 * Handle the dropdown via keyboard to ensure accessibility.
 *
 * @param {Event} e - event for selecting an option
 */
const handleKeyPress = e => {
    const selectContainer = e.currentTarget;

    if (selectContainer.classList.contains('is-open')) {
        keyboardNavigate(e, selectContainer);
    } else if (
        e.key === keyCodes.ENTER ||
        e.key === keyCodes.SPACE ||
        e.key === keyCodes.SPACE_IE11 ||
        e.key === keyCodes.ARROW_DOWN ||
        e.key === keyCodes.ARROW_UP ||
        e.key === keyCodes.ARROW_UP_IE11 ||
        e.key === keyCodes.ARROW_DOWN_IE11 ||
        (e.altKey &&
            (e.key === keyCodes.ARROW_DOWN ||
                e.key === keyCodes.ARROW_UP ||
                e.key === keyCodes.ARROW_UP_IE11 ||
                e.key === keyCodes.ARROW_DOWN_IE11))
    ) {
        toggleSelect(e);
    }
};

/**
 * Initializes the custom select component.
 */
export default () => {
    const selections = document.querySelectorAll('.custom-select');
    selections.forEach(selection => {
        selection.addEventListener('click', toggleSelect);
        selection.addEventListener('keydown', handleKeyPress);
        const selectOptions = selection.querySelector('.custom-select__options');
        const allOptions = selectOptions.querySelectorAll('.custom-select__option');
        allOptions.forEach(option => option.addEventListener('click', selectOptionHandler));
    });
    $('.newsletter-confirm-content').on('click', '.newsletter-unsubscribe-button', function () {
        if (!$('#selected-option').hasClass('is-bold')) {
            sessionStorage.setItem('selectedOption', $('#selected-option').text());
        }
    });
};
